import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import * as moment from 'moment'; 

@Injectable()
export class ItalianDateFormatter extends NgbDateParserFormatter {
	parse(value: string): NgbDateStruct {
		if (value) {
			const date = moment(value, 'DD/MM/YYYY');
			return {
				year: date.year(),
				month: date.month() + 1,
				day: date.date()
			}	
		} else {
			return null;
		}
	} 

	format(date: NgbDateStruct): string {
		if (date) {
			return moment({...date, month: date.month - 1}).format('DD/MM/YYYY');
		} else {
			return null;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/model/dateFormatAdapter.ts